// Human-readable label lookups for lead-detail enum codes. Ported from the
// portal's `labels/display.ts` (the subset the shared panels need).

const STATUS_LABEL = {
  '': '—',
  new: 'New',
  contacted: 'Contacted',
  qualified: 'Qualified',
  unqualified: 'Unqualified',
  customer: 'Customer',
} as const;
const TEMP_LABEL = { '': '—', hot: '🔥 Hot', warm: 'Warm', cold: 'Cold' } as const;
// `system` is not a rep capture at all — the platform writes it (a lead move
// leaves a system rawnote recording where the lead came from). It was
// missing here, so `displayName` fell through to `?? code` and NotesPanel would
// have printed the bare lowercase enum next to a note the rep never wrote.
const CAPTURE_LABEL = {
  voice: 'Voice note',
  text: 'Typed note',
  card: 'Card scan',
  badge: 'Badge scan',
  system: 'System note',
} as const;
const STAGE_LABEL = {
  discovery: 'Discovery',
  qualifying: 'Qualifying',
  proposal: 'Proposal',
  closed_won: 'Closed Won',
  closed_lost: 'Closed Lost',
} as const;

type Domain = 'status' | 'temp' | 'capture' | 'stage';
const DICT: Record<Domain, Record<string, string>> = {
  status: STATUS_LABEL,
  temp: TEMP_LABEL,
  capture: CAPTURE_LABEL,
  stage: STAGE_LABEL,
};

export function displayName(domain: Domain, code: string | null | undefined): string {
  if (!code) return '';
  return DICT[domain]?.[code] ?? code;
}

// Option lists for the shared edit form's Status/Temperature selects —
// derived from the label maps above so the dropdown text never drifts from
// the read-only display text.
export const STATUS_OPTIONS = (Object.keys(STATUS_LABEL) as Array<keyof typeof STATUS_LABEL>).map(
  (value) => ({ value, label: STATUS_LABEL[value] }),
);
export const TEMP_OPTIONS = (Object.keys(TEMP_LABEL) as Array<keyof typeof TEMP_LABEL>).map(
  (value) => ({ value, label: TEMP_LABEL[value] }),
);
